(() => {
  const banner = document.querySelector('[data-gio-cookie-consent]');
  if (!banner || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

  const preferencesPanel = banner.querySelector('[data-gio-cookie-preferences]');
  const toggleButton = banner.querySelector('[data-gio-cookie-toggle]');
  const status = banner.querySelector('[data-gio-cookie-status]');
  const analyticsInput = banner.querySelector('[data-gio-consent-analytics]');
  const marketingInput = banner.querySelector('[data-gio-consent-marketing]');
  const preferencesInput = banner.querySelector('[data-gio-consent-preferences]');
  const isLocalPreview = window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';
  const localPreviewKey = 'gio_cookie_consent_preview_v1';

  let privacyApi = null;

  const getLocalPreviewConsent = () => {
    if (!isLocalPreview) return null;

    try {
      return JSON.parse(window.localStorage.getItem(localPreviewKey));
    } catch (_error) {
      return null;
    }
  };

  const setLocalPreviewConsent = (consent) => {
    if (!isLocalPreview) return;
    window.localStorage.setItem(localPreviewKey, JSON.stringify(consent));
  };

  const setPreferencesOpen = (open) => {
    preferencesPanel.hidden = !open;
    toggleButton.setAttribute('aria-expanded', String(open));
  };

  const fillInputs = () => {
    if (!privacyApi) return;
    const consent = privacyApi.currentVisitorConsent();
    const localConsent = getLocalPreviewConsent();
    analyticsInput.checked = consent.analytics === 'yes' || localConsent?.analytics === true;
    marketingInput.checked = consent.marketing === 'yes' || localConsent?.marketing === true;
    preferencesInput.checked = consent.preferences === 'yes' || localConsent?.preferences === true;
  };

  const hasConsentDecision = () => {
    if (!privacyApi) return false;
    const consent = privacyApi.currentVisitorConsent();
    const shopifyHasDecision = [consent.analytics, consent.marketing, consent.preferences].some(
      (value) => value === 'yes' || value === 'no'
    );
    return shopifyHasDecision || Boolean(getLocalPreviewConsent());
  };

  const showBanner = (openPreferences = false) => {
    fillInputs();
    status.textContent = '';
    banner.hidden = false;
    setPreferencesOpen(openPreferences);
  };

  const saveConsent = (consent) => {
    if (!privacyApi) {
      status.textContent = 'Die Cookie-Einstellungen konnten nicht geladen werden. Bitte versuche es erneut.';
      showBanner(true);
      return;
    }

    banner.dataset.saving = 'true';
    setLocalPreviewConsent(consent);
    privacyApi.setTrackingConsent(consent, () => {
      banner.hidden = true;
      banner.dataset.saving = 'false';
      setPreferencesOpen(false);
    });
  };

  banner.querySelector('[data-gio-cookie-accept]').addEventListener('click', () => {
    saveConsent({ analytics: true, marketing: true, preferences: true });
  });

  banner.querySelector('[data-gio-cookie-reject]').addEventListener('click', () => {
    saveConsent({ analytics: false, marketing: false, preferences: false });
  });

  banner.querySelector('[data-gio-cookie-save]').addEventListener('click', () => {
    saveConsent({
      analytics: analyticsInput.checked,
      marketing: marketingInput.checked,
      preferences: preferencesInput.checked,
    });
  });

  toggleButton.addEventListener('click', () => {
    setPreferencesOpen(preferencesPanel.hidden);
  });

  document.querySelectorAll('[data-gio-cookie-settings]').forEach((button) => {
    button.addEventListener('click', () => showBanner(true));
  });

  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    (error) => {
      if (error || !window.Shopify.customerPrivacy) {
        banner.hidden = false;
        setPreferencesOpen(true);
        status.textContent = 'Die Cookie-Einstellungen konnten nicht geladen werden. Bitte lade die Seite erneut.';
        return;
      }

      privacyApi = window.Shopify.customerPrivacy;
      fillInputs();
      banner.hidden = hasConsentDecision();
    }
  );
})();
